const food = [
  {
    id: 1,
    key: 'item1',
    foodName: 'Burger',
    restaurantName: 'Burger King',
    src: 'https://images.pexels.com/photos/8969237/pexels-photo-8969237.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 15,
    calories: 550,
    carbs: 40,
    fat: 25,
    protein: 20,
    tags: ['non-veg', 'fast food'],
    ingredients: ['beef patty', 'bun', 'lettuce', 'cheese', 'sauce'],
    price: 5.99,
    rating: 5,
    quantity: 1,
  },
  {
    id: 2,
    key: 'item2',
    foodName: 'Pizza',
    restaurantName: 'Pizza Hut',
    src: 'https://images.pexels.com/photos/1099680/pexels-photo-1099680.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 20,
    calories: 800,
    carbs: 60,
    fat: 35,
    protein: 30,
    tags: ['veg', 'Italian'],
    ingredients: ['dough', 'tomato sauce', 'cheese', 'pepperoni'],
    price: 12.99,
    rating: 4,
    quantity: 1,
  },
  {
    id: 3,
    key: 'item3',
    foodName: 'Sushi',
    restaurantName: 'Sushi Bar',
    src: 'https://images.pexels.com/photos/7245465/pexels-photo-7245465.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 30,
    calories: 400,
    carbs: 45,
    fat: 10,
    protein: 15,
    tags: ['non-veg', 'Japanese'],
    ingredients: ['rice', 'fish', 'seaweed', 'wasabi', 'soy sauce'],
    price: 18.99,
    rating: 4.5,
    quantity: 1,
  },
  {
    id: 4,
    key: 'item4',
    foodName: 'Taco',
    restaurantName: 'Taco Bell',
    src: 'https://images.pexels.com/photos/10296413/pexels-photo-10296413.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 10,
    calories: 350,
    carbs: 30,
    fat: 15,
    protein: 20,
    tags: ['non-veg', 'Mexican'],
    ingredients: ['tortilla', 'ground beef', 'lettuce', 'salsa'],
    price: 7.99,
    rating: 3.9,
    quantity: 1,
  },
  {
    id: 5,
    key: 'item5',
    foodName: 'Salad',
    restaurantName: 'Green Garden',
    src: 'https://images.pexels.com/photos/8963467/pexels-photo-8963467.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 5,
    calories: 250,
    carbs: 15,
    fat: 10,
    protein: 5,
    tags: ['veg', 'healthy'],
    ingredients: ['lettuce', 'tomato', 'cucumber', 'vinaigrette'],
    price: 6.99,
    rating: 4.8,
    quantity: 1,
  },
  {
    id: 6,
    key: 'item6',
    foodName: 'Pasta',
    restaurantName: 'Italian Delight',
    src: 'https://images.pexels.com/photos/699953/pexels-photo-699953.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 25,
    calories: 600,
    carbs: 50,
    fat: 20,
    protein: 15,
    tags: ['veg', 'Italian'],
    ingredients: ['pasta', 'tomato sauce', 'parmesan cheese'],
    price: 9.99,
    rating: 4.7,
    quantity: 1,
  },
  {
    id: 7,
    key: 'item7',
    foodName: 'Sushi Rolls',
    restaurantName: 'Sushi Fusion',
    src: 'https://images.pexels.com/photos/8951492/pexels-photo-8951492.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 35,
    calories: 450,
    carbs: 35,
    fat: 12,
    protein: 18,
    tags: ['non-veg', 'Japanese'],
    ingredients: ['rice', 'fish', 'avocado', 'seaweed'],
    price: 14.99,
    rating: 5,
    quantity: 1,
  },
  {
    id: 8,
    key: 'item8',
    foodName: 'Sandwich',
    restaurantName: 'Subway',
    src: 'https://images.pexels.com/photos/1647163/pexels-photo-1647163.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 12,
    calories: 400,
    carbs: 40,
    fat: 15,
    protein: 25,
    tags: ['veg', 'fast food'],
    ingredients: ['bread', 'lettuce', 'tomato', 'turkey'],
    price: 8.99,
    rating: 4.9,
    quantity: 1,
  },
  {
    id: 9,
    key: 'item9',
    foodName: 'Ice Cream',
    restaurantName: 'Sweet Treats',
    src: 'https://images.pexels.com/photos/16560511/pexels-photo-16560511/free-photo-of-a-white-plate-with-three-different-ice-cream-sundaes.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 8,
    calories: 300,
    carbs: 35,
    fat: 10,
    protein: 5,
    tags: ['veg', 'dessert'],
    ingredients: ['vanilla ice cream', 'chocolate syrup', 'whipped cream'],
    price: 3.99,
    rating: 5,
    quantity: 1,
  },
  {
    id: 10,
    key: 'item10',
    foodName: 'Fried Chicken',
    restaurantName: "Mama's Kitchen",
    src: 'https://images.pexels.com/photos/2338407/pexels-photo-2338407.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    waitingTime: 18,
    calories: 700,
    carbs: 45,
    fat: 40,
    protein: 30,
    tags: ['non-veg', 'Indian'],
    ingredients: ['chicken', 'seaweed', 'wasabi', 'soy sauce'],
    price: 3.99,
    rating: 4,
    quantity: 1,
  },
];
export default food;
